export class SaQueuedOperation {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    operationId: string;
    status: 'Queued';
}

export enum BackgroundOperationStatus
{
    Queued,
    Running,
    Completed,
    Failed
}

export class SaBackgroundOperationStatus {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    operationId: string;
    siteId: number;
    orgId: number;
    status: BackgroundOperationStatus;
    progressPercent: number;
    message: string | null;
    errorMessage: string | null;
}
